export default __webpack_public_path__ + "static/media/golo-no.a391bb7b.webp";